import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

export const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer
            style={{
                backgroundColor: '#1a1a2e',
                color: '#a0a0b0',
                fontSize: '0.8rem',
                lineHeight: '1.6',
            }}
        >
            <Container className="py-4">
                <Row>
                    <Col md={8}>
                        <h6 style={{ color: '#e0e0e0', fontWeight: 600, marginBottom: '0.75rem' }}>Risk Disclosure</h6>
                        <p style={{ marginBottom: '0.5rem' }}>
                            Futures, options, and securities trading involves substantial risk of loss and is not suitable for all investors. You should carefully consider whether trading is suitable for you in light of your circumstances, knowledge, and financial resources. You may lose all or more of your initial investment.
                        </p>
                        <p style={{ marginBottom: '0.5rem' }}>
                            Past performance is not indicative of future results. The use of algorithmic trading systems does not guarantee profits or prevent losses. All trading decisions are made by you, the user, and no part of this platform is investment advice, recommendations, or solicitations to buy or sell any financial instruments.
                        </p>
                        <p style={{ marginBottom: '0.5rem' }}>
                            Hypothetical or simulated performance results have certain limitations. Unlike an actual performance record, simulated results do not represent actual trading. Also, since the trades have not been executed, the results may have under- or over-compensated for the impact, if any, of certain market factors, such as lack of liquidity. Simulated trading programs in general are also subject to the fact that they are designed with the benefit of hindsight. No representation is being made that any account will or is likely to achieve profit or losses similar to those shown.
                        </p>
                        <p style={{ marginBottom: '0.5rem' }}>
                            Algorithmic trading signals may not execute as expected due to market conditions, slippage, connectivity issues, or system outages. There is no guarantee that orders will be filled at the intended price or at all.
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            ALM Trading and your licensor are not registered broker-dealers, investment advisors, or commodity trading advisors. ALM Trading and your licensor are not liable for any losses, monetary or otherwise, resulting from the use of this platform.
                        </p>
                    </Col>
                    <Col md={4} className="mt-3 mt-md-0">
                        <h6 style={{ color: '#e0e0e0', fontWeight: 600, marginBottom: '0.75rem' }}>Legal</h6>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                            <Link to="/legal/terms" style={{ color: '#a0a0b0', textDecoration: 'none' }}>
                                Terms & Conditions
                            </Link>
                            <Link to="/legal/privacy" style={{ color: '#a0a0b0', textDecoration: 'none' }}>
                                Privacy Policy
                            </Link>
                        </div>
                    </Col>
                </Row>
                <hr style={{ borderColor: '#2a2a3e', margin: '1rem 0' }} />
                <Row>
                    <Col className="text-center" style={{ marginBottom: '0.5rem' }}>
                        <span>By using this platform, you agree to our <Link to="/legal/terms" style={{ color: '#a0a0b0' }}>Terms & Conditions</Link> and <Link to="/legal/privacy" style={{ color: '#a0a0b0' }}>Privacy Policy</Link>.</span>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <span>&copy; {year} ALM Trading. All rights reserved.</span>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};
